import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import ShowModeAsap from './Asap';
import DeliveryTime from './DeliveryTime';

const SCHEDULE_TYPES = ['SOONEST', 'SCHEDULE'];

const ScheduleSettings = ({
  scheduleType,
  scheduleDate,
  enableEditMode,
  cantinaWeek,
}) => (
  <Wrapper style={{ zIndex: 1 }} onClick={enableEditMode}>
    {scheduleType === 'SOONEST' ? (
      <ShowModeAsap />
    ) : (
      <DeliveryTime
        description={scheduleDate}
        cantinaEnabled={Boolean(cantinaWeek)}
      />
    )}
  </Wrapper>
);

ScheduleSettings.propTypes = {
  scheduleType: PropTypes.oneOf(SCHEDULE_TYPES).isRequired,
  enableEditMode: PropTypes.func.isRequired,
  scheduleDate: PropTypes.string.isRequired,
  cantinaWeek: PropTypes.shape({
    start: PropTypes.object,
    stop: PropTypes.object,
  }),
};

ScheduleSettings.defaultProps = {
  cantinaWeek: null,
};

export default ScheduleSettings;

const Wrapper = styled.div`
  position: relative;
  z-index: 20;
`;
